import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { actions } from "store"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { markingWordsCompleteFetch } from "store/middlewares/markingWords.crud"
import { queryClient as qc } from "keys"
import { markingWordsHooks } from ".."

const useSaveComplete = () => {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    const { assessment } = useSelector(state => state.assessment)
    const { save, loading: saveLoading } = markingWordsHooks.useSave()

    const isTraining = markingWordsHooks.useIsTraining()

    const { mutateAsync: markingWordsCompleteRQ, isPending: markingWordsCompleteLoading } = useMutation({
        mutationFn: markingWordsCompleteFetch,
        onError: () => queryClient.invalidateQueries({ queryKey: [qc.assessmentAndWords] })
    })

    const markingWordsComplete = async () => {
        dispatch(actions.setIsCloseSttoper(true))

        const data = await save()
        if (data) {
            await markingWordsCompleteRQ({ id: assessment.id, data, isTrainingAssessment: isTraining })
        }
    }

    return {
        saveComplete: markingWordsComplete,
        loading: saveLoading || markingWordsCompleteLoading
    }
}

export default useSaveComplete